<template>
  <div class="layout" :class="{'layout-hide-text': spanLeft < 4}" style="min-width:1280px">
    <Row type="flex" style="flex-wrap:nowrap">
      <Col :span="spanLeft" class="layout-menu-left" id="menuLeft">
        <Menu
          ref="slideMenu"
          :active-name="h5active"
          theme="dark"
          width="auto"
          accordion
          id="menuTitle"
        >
          <div class="layout-logo-left" id="title">小 罐 茶</div>
          <router-link to="/H5Checkandreceive" v-if="xgth5user !== '管理员'">
            <MenuItem name="1">
              <Icon type="ios-paper" />
              <span class="layout-text">核对领奖</span>
            </MenuItem>
          </router-link>
          <router-link to="/H5Listofawards">
            <MenuItem name="2">
              <Icon type="ios-people" />
              <span class="layout-text">获奖名单</span>
            </MenuItem>
          </router-link>
        </Menu>
      </Col>
      <Col :span="spanRight" style="overflow-y:auto;">
        <div class="layout-header">
          <div id="person">
            <span style="padding:0 10px 0 10px;cursor: pointer;" @click="exit()">退出登录</span>
            <span @click="exit()" id="exit">
              <Icon type="md-power" style="margin:0 20px 0 0" size="18"></Icon>
            </span>
          </div>
        </div>
        <div class="layout-breadcrumb"></div>
        <div class="layout-content">
          <h1
            v-if="$route.matched.length === 1"
            style="text-align:center;margin-top:0px;margin-bottom:30px;"
            class="animated zoomIn welcomeText"
          >
            <i>欢 迎 来 到 小 罐 茶 H 5 后 台 管 理 系 统</i>
          </h1>
          <keep-alive>
            <router-view v-if="$route.meta.keepAlive"></router-view>
          </keep-alive>
          <router-view v-if="!$route.meta.keepAlive"></router-view>
        </div>
      </Col>
    </Row>
  </div>
</template>

<script>
export default {
  data() {
    return {
      h5active: 1,
      spanLeft: 4,
      spanRight: 20,
      currentName: "",
      xgth5token: "",
      xgth5user: ""
    };
  },
  // 监听,当路由发生变化的时候执行
  watch: {
    $route(to, from) {
      // console.log(to.path,from.path)
      if (to.path == "/H5Checkandreceive") {
        sessionStorage.setItem("h5active", 1);
      } else if (to.path == "/H5Listofawards") {
        sessionStorage.setItem("h5active", 2);
      }
    }
  },
  computed: {},
  methods: {
    // 退出登录
    exit() {
      localStorage.removeItem("xgth5token");
      localStorage.removeItem("xgth5user");
      sessionStorage.clear();
      this.$router.push({
        path: "/H5BackLogin"
      });
      document.title = "  小罐茶  ";
    }
  },
  created() {
    this.xgth5user = localStorage.getItem("xgth5user");
    this.xgth5token = localStorage.getItem("xgth5token");
    if (this.xgth5token !== null) {
      // console.log(this.xgth5token)
    } else {
      this.$router.push({
        path: "/H5BackLogin"
      });
    }
    this.h5active = sessionStorage.getItem("h5active");
  }
};
</script>

<style scoped>
.ivu-btn-text:focus {
  box-shadow: none;
}

.layout {
  border: 1px solid #d7dde4;
  background: #f5f7f9;
  position: relative;
  border-radius: 4px;
  overflow: hidden;
}

.layout-breadcrumb {
  padding: 10px 15px 0;
}

.layout-content {
  /* padding: 10px; */
  min-height: 200px;
  margin: 15px;
  overflow: hidden;
  /* background: #fff; */
  border-radius: 4px;
}

.layout-content-main {
  padding: 10px;
}

.layout-copy {
  text-align: center;
  padding: 10px 0 20px;
  color: #9ea7b4;
  position: absolute;
  width: 100%;
  bottom: 0;
}

.layout-menu-left {
  background: #464c5b;
  min-width: 140px;
}

.layout-header {
  height: 60px;
  background: #fff;
  box-shadow: 0 1px 1px rgba(0, 0, 0, 0.1);
}

.layout-logo-left {
  width: 90%;
  height: 30px;
  line-height: 30px;
  text-align: center;
  background: #5b6270;
  border-radius: 3px;
  margin: 15px auto;
  color: #fff;
  font-weight: bold;
  font-size: 20px;
  cursor: pointer;
}

.layout-ceiling-main a {
  color: #9ba7b5;
}

.layout-hide-text .layout-text {
  display: none;
}

.ivu-col {
  transition: width 0.2s ease-in-out;
}

#person {
  float: right;
  height: 100%;
  display: flex;
  display: -webkit-flex;
  align-items: center;
}

#exit {
  cursor: pointer;
}

.welcomeText {
  color: #dc2829;
  background-image: -webkit-linear-gradient(92deg, #f21c11, #f65951);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}

#menuBtn {
  height: 100%;
}
.ivu-menu {
  padding-top: 1px;
  padding-bottom: 20px;
}
</style>
